import * as numeral from 'numeral';
import 'numeral/locales/pt-br';

export const pieChartMoneyOptions: any = {
  legend: {
    display: true,
  },
  tooltips: {
    callbacks: {
      label: (tooltipItem, data) => {
        const allData = data.datasets[tooltipItem.datasetIndex].data;
        const tooltipLabel = data.labels[tooltipItem.index];
        const tooltipData = allData[tooltipItem.index];
        let total = 0;
        for (let i in allData) {
          total += allData[i];
        }
        const tooltipPercentage = Math.round((tooltipData / total) * 100);
        return `${ tooltipLabel }: ${ numeral(tooltipData).format('$ 0,0.00') } (${ tooltipPercentage }%)`;
      }
    }
  }
};
